import styled from 'styled-components';

export const TitleTextField = styled.h5`
  margin:0
  font-size: 15px;
  margin-top:12px;
`;
